import axios from "axios";
import * as auth from "firebase/auth";
import { basecampApiRequest } from "./basecamp";

export const request = axios.create({
  baseURL: process.env.REACT_APP_BASE_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

export const getCustomFirebaseLoginToken = async (userToken: string) => {
  try {
    const response = await request<{ customToken: string }>(
      "/api/auth/get-admin-custom-firebase-token",
      {
        method: "get",
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      }
    );
    return response.data.customToken;
  } catch (err) {
    console.log(err);
    return null;
  }
};

export const signInWithCustomToken = async (
  userCustomToken: string
): Promise<auth.UserCredential | null> => {
  try {
    return auth.signInWithCustomToken(auth.getAuth(), userCustomToken);
  } catch (e) {
    console.error("Error occured while sign in with custom token");
    console.error(e);
    return null;
  }
};

export const manualRevertTrade = async ({
  tradeId,
  adminUserId,
  adminReason,
  userId,
  token,
}: {
  tradeId: string;
  adminUserId: string;
  adminReason: string;
  userId: string;
  token: string;
}) => {
  if (!token) return;
  try {
    const response = await basecampApiRequest.post(
      `/trades/${tradeId}/manual-revert`,
      {
        adminUserId,
        adminReason,
        tradeId,
        userId,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error occurred while making the POST request:", error);
    throw error;
  }
};
